import styled from 'styled-components'

export const Input = styled.div`
  flex: 1;
  padding: 16px;
`
